const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const reportError = (error: Error | string, context?: Record<string, any>) => {
  const payload = {
    message: typeof error === 'string' ? error : error.message,
    stack: typeof error === 'string' ? null : error.stack,
    url: window.location.href,
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString(),
    ...context,
  };

  // Log locally
  console.error('[FamHearth Error]', payload);

  // Send to server (fire-and-forget)
  fetch(`${API_URL}/api/errors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => {}); // Don't let error reporting cause more errors
};

// Global unhandled error handlers
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    reportError(event.error || event.message);
  });

  window.addEventListener('unhandledrejection', (event) => {
    reportError(event.reason instanceof Error ? event.reason : String(event.reason));
  });
}
